<div class="timeline-container">
  <div class="timeline">
    <div *ngFor="let point of gpsTrack" class="timeline-item" (click)="selectPoint(point)">
      <span>{{ point.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
    </div>
  </div>
  <div id="map" style="width: 100%; height: 400px;"></div>
</div>
